import React from 'react';
import { Helmet } from 'react-helmet-async';

// @mui
import { styled } from '@mui/material/styles';
import { Typography, Box, Button } from '@mui/material';

import pageTitle from '../utils/pageTitles.json';
import { BlankCard } from '../components/cards/blankCard';
import { useNavigate } from 'react-router-dom';
import { checkButtonAccess } from 'src/utils/common';
import CreditPlansSvg from 'src/assets/svgs/voicePlans';
import { NegativeUsersBalanceList } from 'src/sections/voice/negativeUsersBalance/negativeUsersBalanceList';

// home main section container.
const MainSection = styled('div')(({ theme }) => ({
  padding: '64px 20px 0px 88px',
  backgroundColor: 'rgb(240, 240, 240)' /* theme.palette.background.default */,
  height: '100vh',
  overflow: 'hidden',
}));

// Show home hading and filtes
const HeadingSection = styled('div')(() => ({
  width: '100%',
  padding: '20px 0px 20px 0px',
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
}));

const HeadingContentSection = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '15px',
  alignItems: 'center',
  justifyContent: 'center',
}));

const DetailsListSection = styled('div')(() => ({
  width: '100%',
  height: 'calc(100vh - 155px)', //'554px',
  overflow: 'hidden',
  overflowY: 'scroll',
}));
//
const NegativeUsersBalanceListSection = (loadit) => (
  <Box sx={{ width: '100%' }}>
    <DetailsListSection className="reportListScroll">
      <NegativeUsersBalanceList loadit={loadit.loadit} />
    </DetailsListSection>
  </Box>
);

const NegativeUsersBalance = () => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = React.useState(false);
  const [loadit, forceLoad] = React.useState(false);

  const handleClick = () => {
    if (!checkButtonAccess("elasticBackupServer", "w")) return renderErrorMessage(ErrorMessage["invalidClick"])
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <Helmet>
        <title> {`${pageTitle?.negativeVoiceBalance}`} </title>
      </Helmet>

      <MainSection>
        {/* Heading and filters */}
        <HeadingSection>
          <HeadingContentSection>
            <Box
              sx={{
                widht: '16px',
                height: '16px',
                mt: '-10px',
              }}
            >
              <CreditPlansSvg />
            </Box>
            <Typography variant="h5" sx={{ color: 'grey.10', fontWeight: 600 }}>
              Negative Users Balance List
            </Typography>
          </HeadingContentSection>
        </HeadingSection>

        <BlankCard
          key="1"
          sx={{
            height: '100%',
            width: '100%',
            padding: '0px',
            overflow: 'hidden',
            // borderTopLeftRadius: '0px',
            // borderTopRightRadius: '0px'
          }}
        >
          <NegativeUsersBalanceListSection loadit={loadit} sx={{ maxHeight: '100%', overflow: 'hidden' }} />
        </BlankCard>
      </MainSection>
    </>
  );
};

export default NegativeUsersBalance;
